import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import StyledTreeItem from '@material-ui/lab/TreeItem';
import Label from "@material-ui/icons/Label";
import getFields from './ActionFields';

import  '@mui/material/styles';
import Typography from '@mui/material/Typography';
import './dnd.css';
import Box from '@mui/material/Box';
import ContainerIcon from '@material-ui/icons/Mouse';
import MouseIcon from '@material-ui/icons/MouseTwoTone';
import KeyboardIcon from '@material-ui/icons/KeyboardTwoTone';
import BrowserIcon from '@material-ui/icons/Mouse';
import ProcessingIcon from '@material-ui/icons/AssignmentTwoTone';
import FileIcon from '@material-ui/icons/Mouse';
import MathIcon from '@material-ui/icons/AssignmentTwoTone';
import AdvancedIcon from '@material-ui/icons/AssignmentTwoTone';
import MediaIcon from '@material-ui/icons/AssignmentTwoTone';
import ExcelIcon from '@material-ui/icons/AssignmentTwoTone';
import PDFIcon from '@material-ui/icons/AssignmentTwoTone';
import EmailIcon from '@material-ui/icons/AssignmentTwoTone';
import SystemIcon from '@material-ui/icons/AssignmentTwoTone';
import UserInteractionIcon from '@material-ui/icons/AssignmentTwoTone';
import CloudIcon from '@mui/icons-material/Cloud';

import {faBrain, faClock, faDatabase, faBuilding, faCube, faFileExcel, faFan, faGlobe, faMouse, faKeyboard, faPeopleArrows, faEnvelope, faCalculator, faPhotoVideo, faUser, faMicrochip, faFile, faFilePdf, faRocket, faFileImage, faCloud} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSalesforce} from '@fortawesome/free-brands-svg-icons';

import { LightTooltip } from './LightTooltip';
import { NoSimRounded } from '@material-ui/icons';

import _ from 'lodash';


// const icons={
//   "Container":ContainerIcon,
//   "Mouse":MouseIcon,
//   "Keyboard":KeyboardIcon,
//   "Browser":BrowserIcon,
//   "File":FileIcon,
//   "Processing":ProcessingIcon,
//   "Math":MathIcon,
//   "Advanced":AdvancedIcon,
//   "Media":MediaIcon,
//   "Excel":ExcelIcon,
//   "PDF":PDFIcon,
//   "Email":EmailIcon,
//   "System":SystemIcon,
//   "UserInteraction":UserInteractionIcon,

// }

const icons={
  "Building Blocks":faCube,
  "Process Elements":faCube,
  "Mouse":faMouse,
  "Keyboard":faKeyboard,
  "Browser":faGlobe,
  "File":faFile,
  "Processing":faMicrochip,
  "Math":faCalculator,
  "Calculation":faCalculator,
  "Advanced":faRocket,
  "Gen-AI":faBrain,
  "Media":faPhotoVideo,
  "Excel":faFileExcel,
  "PDF":faFilePdf,
  "Email":faEnvelope,
  "System":faFan,
  "Communications":faPeopleArrows,
  "User Interaction":faUser,
  "IDP":faFileImage,
  "Data Structures":faBuilding,
  "DateTime":faClock,
  "Database":faDatabase,
  "SalesForce":faCloud,
  "ServiceNow":faCloud,


  "Physical Work":faFile,
  "Miscellaneous":faFan

}




//mostly not used
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 400,
    height:800,
    // backgroundColor:'#f2f2f2',
  },
});

export default function SimpleTree(props) {
  var classes = useStyles();

  if (props.styles != null){
    classes = props.styles;
  }

  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [data, setData] = useState(props.data);
  const [filteredNodes, setFilteredNodes] = useState([]);

  useEffect(() => {
  //   // Call filterNodes separately to get filtered nodes
    // const clone = [...data];
    const deepClone = _.cloneDeep(data);
    const nodes = filterNodes(deepClone, searchText);
    setFilteredNodes(nodes);
    // console.log(nodes)
    if (searchText != '') 
    setExpanded(nodes.map((node) => {
      return node.id
    }))
    else
    setExpanded([])
  
  }, [data, searchText]);
  



  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    setSelected(nodeIds);
  };

  const onDragStart = (event, name, type, classType) => {
    event.dataTransfer.setData('application/reactflow', type);
    console.log(type)
    event.dataTransfer.setData('name', name);
    event.dataTransfer.setData('classType', classType);
    event.dataTransfer.effectAllowed = 'move';
  };

  const onInputchange = (event) => {
    event.preventDefault()
    // console.log("setting search text to " + event.target.value )
    setSearchText( event.target.value )
    // if (event.target.value != '') 
    //   setExpanded([])
    // update the main model to reflect changes in properties
    event.target.setAttribute(event.target.name, event.target.value)
  }  

  //console.log(props.data)

  const designerIconStyle = {
    // backgroundImage:'radial-gradient(#a5a5a5, royalblue)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px'
    // backgroundImage:'linear-gradient(to bottom right, #a5a5a5, royalblue)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px'
    // backgroundImage:'linear-gradient(to bottom right, #feb100, #8da5ed)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px'
    // backgroundImage:'linear-gradient(to bottom right, #dccca9, #8da5ed)', color:'royalblue', padding:'10px', borderRadius:'15px', marginRight:'5px'
    backgroundImage:'linear-gradient(to bottom right, #a5a5a5, royalblue)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px',
    // border: '1px solid #feb200', /* This adds the border with the desired color */
    padding: '10px', /* Padding inside the icon */
    borderRadius: '50%', /* This creates the circular effect */
    marginRight: '5px', /* Adds space to the right */
    width: '15px', /* Ensures the icon is perfectly round */
    height: '15px', /* Same as width to keep it circular */
    display: 'inline-block', /* Ensures the element behaves like an inline element */
    textAlign: 'center', /* Centers the content inside */
    lineHeight: '50px', /* Centers the icon vertically if it's a font-based icon */    
    color:'white'
  }

  
  var id = 0;


  const filterNodes = (nodes, filter) => {
    
    return nodes.filter((node) => {
    if (!node) {
    return false;
    }
  
      var display = node.display;
      if (display === undefined || display === null) {
        display = node.name;
      }
      // console.log(display)
  
      const isMatch = display.toLowerCase().includes(filter.toLowerCase());
      if (isMatch) 
        return true
      else
      {
      var children = []
      if (node.children != undefined && node.children != null)
      {
        children = filterNodes(node.children, filter);
        node.children = children
      }

      return children.length > 0;
    }
    });
  };
    
  
  

  const renderTreeNodes = (data) => {
    // console.log(searchText)
    // console.log(data)
    // console.log("Nodes expanded: " + expanded)

    return data.map((item) => {
      var type = 'default';
      var fields = [];
      var display = ''
      if (item.node != null) {
        type = item.node;
      }
      display = item.display;
      if (display == null || display == '') {
        display = item.name;
      }
      // display = item.name;

      if (item.children == undefined || item.children == null ) {

        return (
          <LightTooltip title={getFields(item.name)['doc']}>
            <TreeItem
              nodeId={id++}
              // nodeId={item.id}
              label={
                <Typography sx={{ color: '#404040', fontSize: '18px' }}>
                  {display}
                </Typography>
              }
              className="dndnode"
              onDragStart={(event) => onDragStart(event, item.name, type, item.classType)}
              draggable
            />
          </LightTooltip>
        );
      } else {

        return (
          <TreeItem nodeId={item.id} label={
            <Box sx={{ display: 'flex', alignItems: 'center', p: 1.0, pr: 0 }}>
              <FontAwesomeIcon icon={icons[item.name]} style={designerIconStyle} size='small' />
              <Typography sx={{ color: '#404040', fontSize: '18px', fontWeight: 'bold' }}>
                {display}
              </Typography>
            </Box>
          }>
            {renderTreeNodes(item.children)}
          </TreeItem>
        );
      }
    }).filter((item) => item !== null); // Remove null elements (excluded nodes)
};

data.forEach((item) => {
  item.id = id++;
});


// var nodesToBeRendered = filterNodes(data, searchText);
// setExpanded(nodesToBeRendered.map((node) => {
//   return node.id
// }))

// console.log("Nodes: "  + JSON.stringify(nodesToBeRendered));

return (

<aside>

    {/* <h2> {props.title}</h2> */}
    <input  style={{ width: '200px', border:'1px solid #ccc' }} placeholder = 'Search' className='searchBox' name= {'search'}  id = {'search'} onChange={onInputchange}></input>
    <br></br>
    <br></br>
    <TreeView 
      className={classes.root}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expanded}

      selected={selected}
      onNodeToggle={handleToggle}
      onNodeSelect={handleSelect}
    >
        {/* {treeNodes(props.data)} */}
        {renderTreeNodes(filteredNodes)}
        {/* {renderTreeNodes(nodesToBeRendered)} */}
    </TreeView>
  
  </aside>
  );
}
